export const HOME_CONSTS = {
    UPDATE_HOME: "UPDATE_HOME",
    GET_HOME_DATA:"GET_HOME_DATA",
};